import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import ModalOverlay from "../modal/ModalOverlay";
import CoinSelect from "./CoinSelect";
import Input from "./Input";
import "./input.css";
import "../modal/modal.css";
import PercentInput from "./PercentInput";
import { CoinButton } from "../buttons/CoinButton";
import { useRecoilValue } from "recoil";
import { configState } from "../../../context/configState";
import { useToken } from "../../../hooks/useToken";
import { walletState } from "../../../context/walletState";
import PulseLoader from "react-spinners/PulseLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import GetBalance from "../balance/GetBalance";

export const InputComponent = ({
  coinName,
  isOutput,
  coinSelect,
  className,
  disabledcoin,
  isLoading,
  settoken1bal = () => {},
}: {
  coinName: string;
  isOutput: boolean;
  coinSelect: React.MouseEventHandler<string>;
  className: string | undefined;
  disabledcoin: String;
  isLoading: boolean;
  settoken1bal?: any;
}) => {
  const [isListOpen, setIsListOpen] = useState(false);
  const [activeToken, setActiveToken] = useState(coinName);
  const [activeCoinBalance, setActiveCoinBalance] = useState<any>();
  const { assetsMap } = useRecoilValue(configState);
  const { address } = useRecoilValue(walletState);

  const activeCoinBalanceHandler = (val: any) => {
    setActiveCoinBalance(val);
  };

  useEffect(() => {
    setActiveToken(coinName);
  }, [coinName]);

  const openModal = () => {
    setIsListOpen(true);
  };

  const closeModal = () => {
    setIsListOpen(false);
  };

  const handleCoinSelect = (asset: any) => {
    setActiveToken(asset);
    coinSelect(asset);
    closeModal();
  };

  return (
    <div className={`input-component-container ${className}`}>
      <div className="icc-coin-balance-wrapper">
        <div onClick={() => openModal()} className="icc-coin-select-wrapper">
          <CoinButton
            onClick={undefined}
            logoUrl={assetsMap[activeToken].logo_URIs.png}
            displayDenom={activeToken}
            coinName={assetsMap[activeToken].name}
            showName={false}
          />
          <FontAwesomeIcon className="coinselecticon" icon={faCaretDown} />
        </div>
        <div className="icc-input-wrapper">
          <Input disabled={isOutput} tokenName={activeToken} />
          <div className="icc-balance-wrapper">
            <div className="wrapper-para">In Wallet</div>:{" "}
            {!address ? (
              "-"
            ) : (
              <GetBalance
                token={activeToken}
                fetchBal={activeCoinBalanceHandler}
                customCss="height-get-balance"
                settokenBal={settoken1bal ? settoken1bal : () => {}}
                dataRefetch = {isLoading}
              />
            )}
          </div>
        </div>
      </div>

      {!isOutput && (
        <div className="icc-percent-input-wrapper">
          <PercentInput bal={activeCoinBalance} inputVal={() => {}} />
        </div>
      )}
      <Modal
        isOpen={isListOpen}
        onRequestClose={closeModal}
        contentLabel="Select Coin"
        className="custom-modal"
      >
        <div className="modal-close-wrapper">
          <span
            onClick={closeModal}
            className="material-symbols-outlined modal-close-button"
          >
            close
          </span>
        </div>
        <CoinSelect
          coinSelected={(asset) => {
            handleCoinSelect(asset);
          }}
          disabledCoin={disabledcoin}
        />
      </Modal>
    </div>
  );
};

export const OutputComponent = () => {
  return (
    <div className="input-component-container">
      <div className="icc-coin-select-wrapper">{/* <CoinSelect /> */}</div>
      <div className="icc-input-wrapper">{/* <Input /> */}</div>
      {/* <div className="icc-percent-input-wrapper">
        <PercentInput />
      </div> */}
    </div>
  );
};

// export default InputComponent;
